module.exports = "*:not(.fa) {\n  font-family: \"Cairo\", sans-serif;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/financial/claims-view/modals/view-payment-modal/view-payment-modal.component.css
// module id = ./src/app/financial/claims-view/modals/view-payment-modal/view-payment-modal.component.css
// module chunks = main